import { GenerateModalWithSuspense } from "@libs/modal-panels/modal-registry-helpers";
import { iModalProps } from "@libs/modal-panels/modal-registry-model";
import React from "react";

const VoiceMessageRecorderModal = React.lazy(
  () => import("./voice-message-recorder.modal"),
);

const VoiceMessageRecorder: iModalProps<
  typeof VoiceMessageRecorderModal,
  {
    conversationId: string;
    onCompleted: (file: { url: string; fileName: string }) => any;
  }
> = {
  name: "voice-message-recorder",
  component: GenerateModalWithSuspense(VoiceMessageRecorderModal),
};

export default VoiceMessageRecorder;
